import { PaymentRowLayout } from "./PaymentRowLayout";
import React from "react";
import { EVoucherStatus } from "../../../../common/Constants";

export default function PaymentEVouchers(props) {
  const { data, eVouchers } = props;

  if (!data.length) {
    return null;
  }

  return (
    <>
      {data.map((item) => {
        const eVoucher = eVouchers.find((x) => x.id === item.eVoucherId);
        const status = eVoucher?.status ?? "Unknown";
        return (
          <PaymentRowLayout
            key={item.id}
            first={`Evoucher<${eVoucher?.eVoucherProgram?.shortName ?? ""}>`}
            second={
              <span>
                {item.eVoucherCode}{" "}
                <span className={EVoucherStatus.getColor(status)}>
                  ({status})
                </span>
              </span>
            }
            third={(item.amountCollect ?? 0).toFixed(6)}
          />
        );
      })}
    </>
  );
}
